import React, { useState, Fragment } from 'react'
 
import PropTypes from 'prop-types'
 
import './features24.css'
 
const Features24 = (props) => {
  const [activeTab, setActiveTab] = useState(0)
  return (
    <div className="features24-container1 thq-section-padding">
      <div className="features24-container2 thq-section-max-width">
        <div className="features24-image-container">
          {activeTab === 3 && (
            <img
              alt={props.imageAlt}
              src={props.imageSrc}
              className="features24-image"
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          )}
          {activeTab === 1 && (
            <img
              alt={props.feature2ImgAlt}
              src={props.feature2ImgSrc}
              className="features24-image"
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          )}
          {activeTab === 2 && (
            <img
              alt={props.feature3ImgAlt}
              src={props.feature3ImgSrc}
              className="features24-image"
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          )}
          {activeTab === 0 && (
            <img
              alt={props.feature1ImgAlt}
              src="/Research_Innovation.jpg"
              className="features24-image"
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          )}
        </div>
        <div className="features24-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features24-tab-horizontal1"
          >
            <div className="features24-divider-container1">
              {activeTab === 0 && <div className="features24-container3"></div>}
            </div>
            <div className="features24-content1">
              <h2>
                {props.feature1Title ?? (
                  <Fragment>
                    <h2 className="features24-text5 thq-heading-2">
                      Capacity Building
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features24-text6 thq-body-small">
                      Empowering individuals and organizations with the
                      knowledge and skills to harness the potential of AI.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features24-tab-horizontal2"
          >
            <div className="features24-divider-container2">
              {activeTab === 1 && <div className="features24-container4"></div>}
            </div>
            <div className="features24-content2">
              <h2>
                {props.feature2Title ?? (
                  <Fragment>
                    <h2 className="features24-text2 thq-heading-2">
                      Ethical Standards
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features24-text4 thq-body-small">
                      Promoting ethical guidelines and best practices to ensure
                      AI technologies are developed and used responsibly.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features24-tab-horizontal3"
          >
            <div className="features24-divider-container3">
              {activeTab === 2 && <div className="features24-container5"></div>}
            </div>
            <div className="features24-content3">
              <h2>
                {props.feature3Title ?? (
                  <Fragment>
                    <h2 className="features24-text1 thq-heading-2">
                      Sectoraal Use of AI
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="features24-text3 thq-body-small">
                      Advocating for the development of AI solutions that are
                      accessible and beneficial to all members of society.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(3)}
            className="features24-tab-horizontal4"
          >
            <div className="features24-divider-container4">
              {activeTab === 3 && <div className="features24-container6"></div>}
            </div>
            <div className="features24-content4">
              <h2>
                {props.feature1Title1 ?? (
                  <Fragment>
                    <h2 className="features24-text7 thq-heading-2">
                      Governance and Policy
                    </h2>
                  </Fragment>
                )}
              </h2>
              <span>
                {props.feature1Description1 ?? (
                  <Fragment>
                    <span className="features24-text8 thq-body-small">
                      Empowering individuals and organizations with the
                      knowledge and skills to harness the potential of AI.
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
 
Features24.defaultProps = {
  feature3Title: undefined,
  feature2Title: undefined,
  feature3Description: undefined,
  imageSrc:
    'Policy_Development.jpg',
  feature2Description: undefined,
  imageAlt: 'image',
  feature2ImgAlt: 'image',
  feature1ImgAlt: 'feature 1',
  feature2ImgSrc:
    'Capacity_Building.jpg',
  objectFit: 'contain',
  feature1Title: undefined,
  feature3ImgSrc:
    'Data_Infrastructure.jpg',
  feature1Description: undefined,
  feature1Title1: undefined,
  feature1Description1: undefined,
  feature3ImgAlt: 'image',
}
 
Features24.propTypes = {
  feature3Title: PropTypes.element,
  feature2Title: PropTypes.element,
  feature3Description: PropTypes.element,
  imageSrc: PropTypes.string,
  feature2Description: PropTypes.element,
  imageAlt: PropTypes.string,
  feature2ImgAlt: PropTypes.string,
  feature1ImgAlt: PropTypes.string,
  feature2ImgSrc: PropTypes.string,
  feature1Title: PropTypes.element,
  feature3ImgSrc: PropTypes.string,
  feature1Description: PropTypes.element,
  feature1Title1: PropTypes.element,
  feature1Description1: PropTypes.element,
  feature3ImgAlt: PropTypes.string,
}
 
export default Features24